/**
 * Time synchronization data types
 */

export interface ClientServerTimeDiff {
  /** Time difference in milliseconds (positive = client ahead, negative = client behind) */
  diffMs: number;
  /** Client timestamp in milliseconds */
  clientTime: number;
  /** Server timestamp in milliseconds */
  serverTime: number;
  /** Human-readable description of the difference */
  description: string;
}

/** Threshold in milliseconds - only log/track if difference exceeds this value */
export const TIME_DIFF_THRESHOLD_MS = 10000; // 10 seconds
